<template>
  <Swipe :autoplay="2000" lazy-render>
    <SwipeItem v-for="image in images" :key="image">
      <Image :src="image"></Image>
    </SwipeItem>
  </Swipe>
  <Grid :column-num="5" class="menu-gridItem">
    <GridItem icon="orders-o" text="订单管理" to="/order"/>
    <GridItem icon="brush-o" text="设计管理" to="/design"/>
    <GridItem icon="logistics" text="物流管理" to="/logistics"/>
    <GridItem icon="hotel-o" text="生产管理" to="/production"/>
    <GridItem icon="cluster-o" text="运维管理" to="/devOps"/>
    <GridItem icon="cash-o" text="账单审批" to="/collection"/>
    <GridItem icon="shopping-cart-o" text="商品管理" to="/goods"/>
    <GridItem to="/investment">
      <template #icon>
        <span class="iconfont icon-qian my-gridItem"></span>
      </template>
      <template #text>
        <span style="font-size: 12px;font-weight: bold">{{ inMiniProgram ? '支持者专栏' : '投资专栏' }}</span>
      </template>
    </GridItem>
    <GridItem icon="chart-trending-o" text="销售统计" to="/statistics"/>
    <GridItem icon="balance-pay" text="薪资管理" to="/salary"/>
  </Grid>
  <Cell style="margin-top: 5px;">
    <template #title>
      <span class="my0" style="color:var(--base-color)">订单<span
          style="border-bottom: 4px solid #f6b1b8">统计</span></span>
    </template>
    <!--    <template #value>-->
    <!--      <DropdownMenu>-->
    <!--        <DropdownItem v-model="orderDateType" :options="option1"/>-->
    <!--      </DropdownMenu>-->
    <!--    </template>-->
    <template #right-icon>
       <span class="my0">
         <Icon name="arrow-down" size="18" @click="showDatePicker = !showDatePicker"/>
       </span>
    </template>
    <template #value>
      <span class="my0">{{ timeFormatText }}</span>
    </template>
  </Cell>

  <CellGroup>
    <Cell center class="my-cell-title">
      <template #title>
        <span style="font-weight: bold;font-size: 15px">新增业绩量</span>
      </template>
      <template #label>
        <Row :gutter="10">
          <Col :span="24" class="mylineheight">
            <span class="num2">1.0（英区）</span>
            <span class="num1">{{ taskCount.oneOrderUkCount }}</span>
            量
            <!--            <span class="num1">{{ taskCount.count }}</span>-->
            <!--            单-->
          </Col>
          <Col :span="24" class="mylineheight">
            <span class="num2">1.0（欧区）</span>
            <span class="num1">{{ taskCount.oneOrderEurCount }}</span>
            量
          </Col>
          <Col :span="24" class="mylineheight">
            <span class="num2">1.0（美区）</span>
            <span class="num1">{{ taskCount.oneOrderUSKCount }}</span>
            量
          </Col>
          <Col :span="24" class="mylineheight">
            <span class="num2">2.0 续费 </span>
            <!--            <span class="num1">{{ taskCount.countTwoWorkload }}</span>-->
            <!--            量-->
            <!--            <span class="num1">{{ taskCount.countTwo }}</span>-->
            <!--            单-->
            <!--            <span class="num2">续费</span>-->
            <!--            <span class="num1">{{ taskCount.countTwoRenewWorkload }}</span>-->
            <!--            量-->
            <span class="num1">{{ taskCount.countRenewTwo }}</span>
            单
          </Col>
          <Col :span="24" class="mylineheight">
            <span class="num2">2.3 入单电脑 </span>
            <span class="num1">{{ taskCount.twoPThreeOrderCountMonth }}</span>
            单
          </Col>
        </Row>
      </template>

      <template #value>
        <Icon name="new-o" size="40" color="#f17f87"></Icon>
      </template>
    </Cell>
  </CellGroup>

  <CellGroup>
    <Cell style="margin-top: 5px;">
      <template #title>
        <span class="my0" style="color:var(--base-color)">{{ inMiniProgram ? '梦想补给' : '投资' }}<span style="border-bottom: 4px solid #f6b1b8">明细</span></span>
      </template>
    </Cell>

    <Cell center class="my-cell-title">
      <template #title>

      </template>
      <template #label>
<!--        <Row :gutter="10">-->
<!--          <Col :span="24" class="mylineheight">-->
<!--            <span class="num2">投资额 </span>-->
<!--            <span class="num1">{{ taskCount.oneOrderUkCount }}</span>-->
<!--            元-->
<!--          </Col>-->
<!--          <Col :span="24" class="mylineheight">-->
<!--            <span class="num2">股份 </span>-->
<!--            <span class="num1">{{ taskCount.oneOrderEurCount }}</span>-->
<!--          </Col>-->
<!--        </Row>-->
        <Row style="font-size: 18px;line-height: 24px">
          <div>{{ inMiniProgram ? '尊敬的宝藏支持者' : '尊敬的投资人' }}<span style="color: #5f1012;word-break: break-all">&nbsp;{{store.getters.name}}&nbsp;</span></div>
          <template v-if="inMiniProgram">
            您{{ currentYear }}年的梦想补给金为<u class="style-1">&nbsp;{{store.getters.investment}}&nbsp;</u>元，拥有梦想席位<u class="style-1">&nbsp;{{store.getters.stock}}&nbsp;</u> 个。
          </template>
          <template v-else>
            您的{{ currentYear }}年投资额为<u class="style-1">&nbsp;{{store.getters.investment}}&nbsp;</u>元，拥有股份<u class="style-1">&nbsp;{{store.getters.stock}}&nbsp;</u> 股。
          </template>
        </Row>

      </template>



      <template #value>
        <Icon name="balance-o" size="40" color="#f17f87"></Icon>
      </template>
    </Cell>
  </CellGroup>
  <!--    <Cell center class="my-cell-title">-->
  <!--      <template #title>-->
  <!--        <span style="font-weight: bold;font-size: 15px">工作完成量</span>-->
  <!--      </template>-->
  <!--      <template #label>-->
  <!--        <Row>-->
  <!--          <Col :span="24">-->
  <!--            <span class="num2">设计</span>-->
  <!--            <span class="num1">{{ taskCount.finishDraftWorkload }}</span>-->
  <!--            量-->
  <!--&lt;!&ndash;            <span class="num1">{{ taskCount.finishDraftCount }}</span>&ndash;&gt;-->
  <!--&lt;!&ndash;            单&ndash;&gt;-->
  <!--          </Col>-->
  <!--&lt;!&ndash;          <Col :span="24">&ndash;&gt;-->
  <!--&lt;!&ndash;            <span class="num2">发货</span>&ndash;&gt;-->
  <!--&lt;!&ndash;&lt;!&ndash;            <span class="num1">{{ taskCount.finishDeliverWorkload }}</span>&ndash;&gt;&ndash;&gt;-->
  <!--&lt;!&ndash;&lt;!&ndash;            量&ndash;&gt;&ndash;&gt;-->
  <!--&lt;!&ndash;            <span class="num1">{{ taskCount.finishDeliverCount }}</span>&ndash;&gt;-->
  <!--&lt;!&ndash;            单&ndash;&gt;-->
  <!--&lt;!&ndash;          </Col>&ndash;&gt;-->
  <!--        </Row>-->
  <!--      </template>-->
  <!--      <template #value>-->
  <!--        <Icon name="certificate" size="40" color="#fa9334"></Icon>-->
  <!--      </template>-->
  <!--    </Cell>-->

  <!--    <Cell center class="my-cell-title">-->
  <!--      <template #title>-->
  <!--        <span style="font-weight: bold;font-size: 15px">未完成任务量</span>-->
  <!--      </template>-->
  <!--      <template #label>-->
  <!--        <Row>-->
  <!--          <Col :span="24">-->
  <!--            <span class="num2">1.0</span>-->
  <!--            <span class="num1">{{ taskCount.unfinishDraftCount }}</span>-->
  <!--            单-->
  <!--          </Col>-->
  <!--          <Col :span="24">-->
  <!--            <span class="num2">2.0</span>-->
  <!--            <span class="num1">{{ taskCount.unfinishDeliverCount }}</span>-->
  <!--            单-->
  <!--          </Col>-->
  <!--        </Row>-->
  <!--      </template>-->
  <!--      <template #value>-->
  <!--        <Icon name="warning-o" size="40" color="#e9c72b"></Icon>-->
  <!--      </template>-->
  <!--    </Cell>-->

  <Popup :show="showDatePicker" position="bottom" :style="{ height: '40%' }">
    <DatetimePicker
        v-model="selectTime"
        @confirm="confirmFn"
        :max-date="maxDate"
        @cancel="showDatePicker = false"
        title="时间选择"
        type="year-month"
    />
  </Popup>

</template>

<script setup>
import {
  Row,
  Col,
  Swipe,
  SwipeItem,
  Image,
  Grid,
  GridItem,
  Icon,
  Cell,
  CellGroup,
  DropdownMenu,
  DropdownItem,
  Popup,
  DatetimePicker,
} from 'vant';
import {computed, onMounted, reactive, ref, watch} from "vue";

// import invest from '@/assets/invest.jpg'
import p1 from '@/assets/p1.jpg'
import p2 from '@/assets/p2.jpg'
import p3 from '@/assets/p3.jpg'
import p4 from '@/assets/p4.jpg'
import {taskCountByMonth, taskCountLastMonth, taskCountMonth, taskCountYear} from "@/api/homeCount";
import {useStore} from "vuex";
import {isMiniProgram} from "@/utils/env";

const store = useStore()
// 小程序端（对外发布）使用替代文案，屏蔽「投资人 / 投资额 / 股份」等金融化表述；
// 浏览器端保持原样。判定逻辑见 src/utils/env.js
// 2026-10-04 甲方定稿调整：贡献明细→梦想补给明细、尊敬的→尊敬的宝藏支持者、
// 贡献/席位→梦想补给金/梦想席位、发展看板→支持者专栏。
const inMiniProgram = isMiniProgram()
// 页面打开时按用户设备时间获取当前年份。
const currentYear = new Date().getFullYear()
const images = [
  p1, p2, p3, p4
];
const orderDateType = ref(1);
const option1 = [
  {text: '当月', value: 1},
  {text: '上月', value: 2},
  {text: '一年', value: 3},
];
watch(() => orderDateType.value, (newValue, oldValue) => {
  if (newValue == 1) {
    getTaskCountMonth()
  } else if (newValue == 2) {
    getTaskCountLastMonth()
  } else if (newValue == 3) {
    getTaskCountYear()
  }
})
let taskCount = ref({
  count: '',
  finishCount: '',
  unfinishCount: '',
  countTwo: '',
  countWorkload: '',
  countTwoWorkload: '',
  finishWorkload: '',
  finishDraftWorkload: '',
  finishDraftCount: '',
  finishDeliverWorkload: '',
  finishDeliverCount: '',
  unfinishDraftCount: '',
  unfinishDeliverCount: '',
  countTwoRenewWorkload: '',
  countRenewTwo: '',
  twoPThreeOrderCountMonth: '',
  twoPointThreeOrderSumWorkMonth: '',
  oneOrderUkCount: '',
  oneOrderEurCount: '',
  oneOrderUSKCount:''
})

let userId = 14
const getTaskCountMonth = () => {
  taskCountMonth(userId).then(res => {
        if (res.code == '0') {
          taskCount.value = res.data
        } else {
          ElMessage({
            type: "error",
            message: res.msg
          })
        }
      }
  )
}
const getTaskCountLastMonth = () => {
  taskCountLastMonth(userId).then(res => {
        if (res.code == '0') {
          taskCount.value = res.data
        } else {
          ElMessage({
            type: "error",
            message: res.msg
          })
        }
      }
  )
}
const getTaskCountYear = () => {
  taskCountYear(userId).then(res => {
        if (res.code == '0') {
          taskCount.value = res.data
        } else {
          ElMessage({
            type: "error",
            message: res.msg
          })
        }
      }
  )
}

const getTaskCountByMonth = () => {
  taskCountByMonth(userId, timeFormatText.value).then(res => {
        if (res.code == '0') {
          taskCount.value = res.data
        }
      }
  )
}

const maxDate = ref(new Date())

let showDatePicker = ref(false)
let timeFormatText = ref()
let selectTime = ref(new Date())
const confirmFn = () => { // 确定按钮
  timeFormatText.value = timeFormat(selectTime.value);
  getTaskCountByMonth()
  showDatePicker.value = false;

}

const timeFormat = (time) => { // 时间格式化 2019-09-08
  let year = time.getFullYear();
  let month = time.getMonth() + 1;
  return year + '-' + month
}


onMounted(() => {
  timeFormatText.value = timeFormat(new Date())
  getTaskCountByMonth()
})


</script>

<style scoped>
:deep .van-dropdown-menu__item {
  justify-content: flex-end;
  margin-right: 6px;
}

.num1 {
  font-size: 18px;
  color: var(--base-color)
}

.num2 {
  font-size: 14px;
  margin-right: 5px;
}

.menu-gridItem :deep .van-icon {
  background-color: #f37f88;
  color: white;
  padding: 5px;
  border-radius: 20px
}

/*.task-cell :deep .van-cell__title {*/
/*  min-width: 80%;*/
/*  text-align: left;*/
/*}*/

.my-gridItem {
  background-color: #eac058;
  color: white;
  padding: 5px;
  border-radius: 30px;
  font-size: 40px;
  vertical-align: 12px;
}

.my0 {
  font-weight: bold;
  font-size: 18px;
  line-height: 48px;
}

.mylineheight {
  line-height: 25px;
}

.style-1 {
  font-size: 20px;
  color: var(--base-color);
}
</style>
